export default "__VITE_ASSET__BObJGRsC__"